import CardsSkeleton from './CardsSkeleton';

export default CardsSkeleton;
